// extracted by mini-css-extract-plugin
export default {"container":"Ax64h","image":"bx5WV"};